import './Survey.scss';

// SurveyComponent.js
import React, { useState, useRef } from 'react';
import * as Survey from 'survey-react';
import 'survey-react/survey.css';

const SurveyComponent = ({ onCompleteSurvey }) => {
  const surveyRef = useRef(null);
  const [surveyData, setSurveyData] = useState([]);

  const surveyJSON = {
    pages: [
      {
        questions: [
          {
            type: 'matrix',
            name: 'A/ HANDLUNGSSPIELRAUM',
            title: 'A/ HANDLUNGSSPIELRAUM',
            columns: [
              {
                value: 1,
                text: 'sehr wenig'
              },
              {
                value: 2,
                text: 'ziemlich wenig'
              },
              {
                value: 3,
                text: 'etwas'
              },
              {
                value: 4,
                text: 'ziemlich viel'
              },
              {
                value: 5,
                text: 'sehr viel'
              }
            ],
            rows: [
              {
                value: 'Tätigkeit insgesamt',
                text: 'Wenn Du Deine Tätigkeit insgesamt betrachtest, inwieweit kannst Du die Reihenfolge der Arbeitsschritte selbst bestimmen?'
              },
              {
                value: 'Wieviel Einfluss',
                text: 'Wieviel Einfluss hast Du darauf, welche Arbeit Dir zugeteilt wird?'
              },
              {
                value: 'Arbeit selbstständig planen',
                text: 'Kannst Du Deine Arbeit selbstständig planen und einteilen?'
              }
            ],
            alternateRows: true,
            isAllRowRequired: true
          }
        ]
      },
      {
        questions: [
          {
            type: 'matrix',
            name: 'B/ VIELSEITIGES ARBEITEN',
            title: 'B/ VIELSEITIGES ARBEITEN',
            columns: [
              {
                value: 1,
                text: 'trifft gar nicht zu'
              },
              {
                value: 2,
                text: 'trifft wenig zu'
              },
              {
                value: 3,
                text: 'trifft mittel - mäßig zu'
              },
              {
                value: 4,
                text: 'trifft überwie- gend zu'
              },
              {
                value: 5,
                text: 'strifft völlig zu'
              }
            ],
            rows: [
              {
                value: 'affordable',
                text: 'Kannst Du bei Deiner Arbeit Neues dazulernen?'
              },
              {
                value: 'Wissen und Können',
                text: 'Kannst Du bei Deiner Arbeit Wissen und Können voll einsetzen?'
              },
              {
                value: 'unterschiedliche Arbeitsaufgaben',
                text: 'Bei meiner Arbeit habe ich insgesamt gesehen häufig wechselnde, unterschiedliche Arbeitsaufgaben.'
              }
            ],
            alternateRows: true,
            isAllRowRequired: true
          }
        ]
      },
      {
        questions: [
          {
            type: 'matrix',
            name: 'C/ GANZHEITLICHES ARBEITEN',
            title: 'C/ GANZHEITLICHES ARBEITEN',
            columns: [
              {
                value: 1,
                text: 'trifft gar nicht zu'
              },
              {
                value: 2,
                text: 'trifft wenig zu'
              },
              {
                value: 3,
                text: 'trifft mittel - mäßig zu'
              },
              {
                value: 4,
                text: 'trifft überwie- gend zu'
              },
              {
                value: 5,
                text: 'strifft völlig zu'
              }
            ],
            rows: [
              {
                value: 'Ergebnis',
                text: 'Bei meiner Arbeit sehe ich selber am Ergebnis, ob meine Arbeit gut war oder nicht.'
              },
              {
                value: 'Arbeitsprodukt',
                text: 'Meine Arbeit ist so gestaltet, dass ich die Möglichkeit habe, ein vollständiges Arbeitsprodukt von Anfang bis Ende herzustellen.'
              }
            ],
            alternateRows: true,
            isAllRowRequired: true
          }
        ]
      },
      {
        questions: [
          {
            type: 'matrix',
            name: 'D/ SOZIALE RÜCKENDECKUNG',
            title: 'D/ SOZIALE RÜCKENDECKUNG',
            columns: [
              {
                value: 1,
                text: 'trifft gar nicht zu'
              },
              {
                value: 2,
                text: 'trifft wenig zu'
              },
              {
                value: 3,
                text: 'trifft mittel - mäßig zu'
              },
              {
                value: 4,
                text: 'trifft überwie- gend zu'
              },
              {
                value: 5,
                text: 'strifft völlig zu'
              }
            ],
            rows: [
              {
                value: 'Kolleginnen und Kollegen',
                text: 'Ich kann mich auf meine Kolleginnen und Kollegen verlassen, wenn es bei der Arbeit schwierig wird.'
              },
              {
                value: 'Vorgesetzten verlassen',
                text: 'Ich kann mich auf meinen direkten Vorgesetzten verlassen, wenn es bei der Arbeit schwierig wird.'
              },
              {
                value: 'Wir halten in der Abteilung gut zusammen',
                text: 'Wir halten in der Abteilung gut zusammen.'
              }
            ],
            alternateRows: true,
            isAllRowRequired: true
          }
        ]
      },
      {
        questions: [
          {
            type: 'matrix',
            name: 'E/ ZUSAMMENARBEIT',
            title: 'E/ ZUSAMMENARBEIT',
            columns: [
              {
                value: 1,
                text: 'trifft gar nicht zu'
              },
              {
                value: 2,
                text: 'trifft wenig zu'
              },
              {
                value: 3,
                text: 'trifft mittel - mäßig zu'
              },
              {
                value: 4,
                text: 'trifft überwie- gend zu'
              },
              {
                value: 5,
                text: 'strifft völlig zu'
              }
            ],
            rows: [
              {
                value: 'Enge Zusammenarbeit',
                text: 'Meine Arbeit erfordert eine enge Zusammenarbeit mit anderen Kolleginnen und Kollegen im Unternehmen.'
              },
              {
                value: 'Kolleginnen und Kollegen',
                text: 'Ich kann mich während der Arbeit mit verschiedenen Kolleginnen und Kollegen über dienstliche und private Dinge unterhalten.'
              },
              {
                value: 'Rückmeldung',
                text: 'Ich bekomme von Vorgesetzten, Kolleginnen und Kollegen immer Rückmeldung über die Qualität meiner Arbeit.'
              }
            ],
            alternateRows: true,
            isAllRowRequired: true
          }
        ]
      }
      
    ],
    showQuestionNumbers: 'off'
  };
  /*
  const surveyJSON = {
    title: 'AMBION Balance Test',
    pages: [
      {
        questions: [
          {
            type: 'radiogroup',
            name: 'Frage 1',
            title: 'Frage 1: Wie würdest du wählen?',
            choices: [
              { value: 10, text: 'Antwort 1-1' },
              { value: 20, text: 'Antwort 1-2' },
              { value: 30, text: 'Antwort 1-3' },
              { value: 40, text: 'Antwort 1-4' },
              { value: 50, text: 'Antwort 1-5' },
              { value: 60, text: 'Antwort 1-6' },
              { value: 70, text: 'Antwort 1-7' },
              { value: 80, text: 'Antwort 1-8' },
              { value: 90, text: 'Antwort 1-9' }
            ],
            "isRequired": true
          }
          // Add more questions here...
        ]
      },
      {
        questions: [
          {
            type: 'radiogroup',
            name: 'Frage 2',
            title: 'Frage 2: Wie würdest du wählen?',
            choices: [
              { value: 50, text: 'Antwort 2-1' },
              { value: 10, text: 'Antwort 2-2' }
            ],
            "isRequired": true
          }
          // Add more questions here...
        ]
      },
      {
        questions: [
          {
            type: 'radiogroup',
            name: 'Frage 3',
            title: 'Frage 3: Wie würdest du wählen?',
            choices: [
              { value: 20, text: 'Antwort 3-1' },
              { value: 40, text: 'Antwort 3-2' },
              { value: 50, text: 'Antwort 3-3' },
              { value: 60, text: 'Antwort 3-4' },
              { value: 80, text: 'Antwort 3-5' },
              { value: 100, text: 'Antwort 3-6' }
            ],
            "isRequired": true
          }
          // Add more questions here...
        ]
      },
      {
        questions: [
          {
            type: 'radiogroup',
            name: 'Frage 4',
            title: 'Frage 4: Wie würdest du wählen?',
            choices: [
              { value: 10, text: 'Antwort 4-1' },
              { value: 25, text: 'Antwort 4-2' },
              { value: 40, text: 'Antwort 4-3' },
              { value: 60, text: 'Antwort 4-4' },
              { value: 90, text: 'Antwort 4-5' }
            ],
            "isRequired": true
          }
          // Add more questions here...
        ]
      },
      {
        questions: [
          {
            type: 'radiogroup',
            name: 'Frage 5',
            title: 'Frage 5: Wie würdest du wählen?',
            choices: [
              { value: 10, text: 'Antwort 5-1' },
              { value: 50, text: 'Antwort 5-2' },
              { value: 80, text: 'Antwort 5-3' }
            ],
            "isRequired": true
          }
          // Add more questions here...
        ]
      },
      {
        questions: [
          {
            type: 'radiogroup',
            name: 'Frage 6',
            title: 'Frage 6: Wie würdest du wählen?',
            choices: [
              { value: 10, text: 'Antwort 6-1' },
              { value: 30, text: 'Antwort 6-2' },
              { value: 40, text: 'Antwort 6-3' },
              { value: 55, text: 'Antwort 6-4' },
              { value: 70, text: 'Antwort 6-5' },
              { value: 80, text: 'Antwort 6-6' },
              { value: 95, text: 'Antwort 6-7' }
            ],
            "isRequired": true
          }
          // Add more questions here...
        ]
      },
      {
        questions: [
          {
            type: 'radiogroup',
            name: 'Frage 7',
            title: 'Frage 7: Wie würdest du wählen?',
            choices: [
              { value: 10, text: 'Antwort 7-1' },
              { value: 30, text: 'Antwort 7-2' },
              { value: 40, text: 'Antwort 7-3' },
              { value: 55, text: 'Antwort 7-4' },
              { value: 70, text: 'Antwort 7-5' },
              { value: 80, text: 'Antwort 7-6' },
              { value: 95, text: 'Antwort 7-7' }
            ],
            "isRequired": true
          }
          // Add more questions here...
        ]
      },
      {
        questions: [
          {
            type: 'radiogroup',
            name: 'Frage 8',
            title: 'Frage 8: Wie würdest du wählen?',
            choices: [
              { value: 10, text: 'Antwort 8-1' },
              { value: 30, text: 'Antwort 8-2' },
              { value: 40, text: 'Antwort 8-3' },
              { value: 55, text: 'Antwort 8-4' },
              { value: 70, text: 'Antwort 8-5' },
              { value: 80, text: 'Antwort 8-6' },
              { value: 95, text: 'Antwort 8-7' }
            ],
            "isRequired": true
          }
          // Add more questions here...
        ]
      },
      {
        questions: [
          {
            type: 'radiogroup',
            name: 'Frage 9',
            title: 'Frage 9: Wie würdest du wählen?',
            choices: [
              { value: 10, text: 'Antwort 9-1' },
              { value: 30, text: 'Antwort 9-2' },
              { value: 40, text: 'Antwort 9-3' },
              { value: 55, text: 'Antwort 9-4' },
              { value: 70, text: 'Antwort 9-5' },
              { value: 80, text: 'Antwort 9-6' },
              { value: 95, text: 'Antwort 9-7' }
            ],
            "isRequired": true
          }
          // Add more questions here...
        ]
      },{
        questions: [
          {
            type: 'radiogroup',
            name: 'Frage 10',
            title: 'Frage 10: Wie würdest du wählen?',
            choices: [
              { value: 10, text: 'Antwort 10-1' },
              { value: 30, text: 'Antwort 10-2' },
              { value: 40, text: 'Antwort 10-3' },
              { value: 55, text: 'Antwort 10-4' },
              { value: 70, text: 'Antwort 10-5' },
              { value: 80, text: 'Antwort 10-6' },
              { value: 95, text: 'Antwort 10-7' }
            ],
            "isRequired": true
          }
          // Add more questions here...
        ]
      },{
        questions: [
          {
            type: 'radiogroup',
            name: 'Frage 11',
            title: 'Frage 11: Wie würdest du wählen?',
            choices: [
              { value: 10, text: 'Antwort 11-1' },
              { value: 30, text: 'Antwort 11-2' },
              { value: 40, text: 'Antwort 11-3' },
              { value: 55, text: 'Antwort 11-4' },
              { value: 70, text: 'Antwort 11-5' },
              { value: 80, text: 'Antwort 11-6' },
              { value: 95, text: 'Antwort 11-7' }
            ],
            "isRequired": true
          }
          // Add more questions here...
        ]
      }

      // More pages/questions...
    ]
  };
  */

  /*
  const onValueChanged = (survey, { name, question, value }) => {
    const newData = survey.data;

    setSurveyData((prevData) => [...prevData, newData]);
    console.log(surveyData, newData);
    console.log(`The ${name} question value has changed to ${value}.`);
  };
  */

  const onComplete = (survey) => {
    const newData = survey.data;

    setSurveyData((prevData) => [...prevData, newData]);

    // Check if there's another page/question
    if (survey.currentPageNo < survey.visiblePages.length - 1) {
      survey.nextPage(); // Move to the next page
    } else {
      // Pass survey data back to the parent component (onCompleteSurvey prop)
      onCompleteSurvey([...surveyData, newData]);
    }
  };

  Survey.Serializer.addProperty('survey', 'progressTitle');

  //
  return <Survey.Survey json={surveyJSON} onComplete={onComplete} ref={surveyRef} />;
};

export default SurveyComponent;
